import styled, { css, keyframes } from 'styled-components';
import { colors, fonts, helpers } from 'stylesheets';

const { ListMarginBottomItems } = helpers;

export const ChatColumnCard = styled.div`
  width: 41%;
  height: 650px;
  background: ${colors.zircon};
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const TopBar = styled.div`
  width: 100%;
  min-height: 60px;
  max-height: 60px;
  background: ${colors.white};
  border-bottom: 1px solid ${colors.greyLighter};
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 30px;
  cursor: pointer;
  display: flex;
  flex: 1;
`;
export const Button = styled.div`
  width: 121px;
  height: 38px;
  border: 1px solid ${colors.greyLighter};
  border-radius: 3px;
  margin-left: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 7px;
  transition: box-shadow 0.2s;
  span {
    width: 70%;
    color: ${colors.greyDark};
    font-size: 11px;
    font-family: ${fonts.secondary};
  }
  &:hover {
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.25);
    transition: box-shadow 0.2s;
  }
`;

export const Icon = styled.img`
  width: 20px;
  height: 20px;
`;

export const MessagesArea = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const MessageList = styled.div`
  padding: 20px 45px;
  display: flex;
  max-height: 541px;
  flex-direction: column;
  flex: 1 0;
  overflow: auto;
  ${ListMarginBottomItems(8)}
`;

export const Date = styled.span`
    display: block;
    text-align: center;
    color: ${colors.silverChalice};
    font-size: 12px;
    font-family: ${fonts.secondary};
    text-transform: uppercase;
    margin-bottom: 22px;
`;

const blink = keyframes`
  50% {
    opacity: 1;
  }
`;

const bulge = keyframes`
  50% {
    transform: scale(1.05);
  }
`;

const typing = keyframes`
  0%{
    -webkit-transform:translateY(0px)
  }
  28%{
    -webkit-transform:translateY(-5px)
  }
  44%{
    -webkit-transform:translateY(0px)
  }
`;

export const TypingIndicator = styled.div`
  background-color: ${colors.white};
  will-change: transform;
  width: auto;
  border-radius: 30px;
  border-bottom-left-radius: 0px;
  position: relative;
  animation: 2s ${bulge} infinite ease-out;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 30px;
  width: 80px;
  border: 1px solid ${colors.greyLighter};
  margin: 0px 0px 10px 20px;

  & > span {
    height: 8px;
    width: 8px;
    margin: 0 3px;
    background-color: ${colors.greyLight};
    display: block;
    border-radius: 50%;
    opacity: 0.4;
    animation: ${typing} 1.5s infinite ease-in-out;
    &:nth-of-type(1) {
      animation-delay: 200ms;
    }
    &:nth-of-type(2) {
      animation-delay: 300ms;
    }
    &:nth-of-type(3) {
      animation-delay: 400ms;
    }
  }
`;

export const SendBar = styled.form`
  width: 100%;
  max-height: 50px;
  background: ${colors.white};
  bottom: 0px;
  border-top: 1px solid ${colors.greyLighter};
  border-bottom: 1px solid ${colors.greyLighter};
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);
  z-index: 0;
  padding: 10px 20px;
  align-items: center;
  display: flex;
  flex: 1;
`;

export const SendButton = styled.button`
  width: 35px;
  height: 35px;
  border-radius: 100%;
  background: ${colors.greyLighter};
  margin-left: 25px;
  background-size: 70%;
  border: none;
  cursor: pointer;
  transition: 0.5s background;

  &:active,
  &:focus {
    outline: none;
    border: none;
    box-shadow: none;
  }

  ${({ active }) => active
    && css`
      background: ${colors.primary};
      background-size: 70%;
      transition: 0.5s background;
    `}
`;

export const InputMessage = styled.input`
  border-radius: 90px;
  width: 90%;
  border: 1px solid ${colors.greyLight};
  padding-left: 20px;
  transition: 0.5s background;
  &:active,
  &:focus {
    box-shadow: none;
    outline: none;
    border: 1px solid ${colors.greyLighter};
  }
`;
